import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { TutorAvatarProps } from '../types/interfaces'
// assets
import { TUTOR_AVATARS, TUTOR_AVATARS_WEBP } from '../images'

interface TutorAvatarHookOptions {
  props: TutorAvatarProps
}

interface TutorAvatarHookReturn {
  refSrc: ComputedRef<string>
  refWebpSrc: ComputedRef<string>
}

export const useTutorAvatar = ({ props }: TutorAvatarHookOptions): TutorAvatarHookReturn => {
  const refSrc = computed<string>(() => TUTOR_AVATARS[props.name])
  const refWebpSrc = computed<string>(() => TUTOR_AVATARS_WEBP[props.name])

  return {
    refSrc,
    refWebpSrc,
  }
}
